import { getSnackbarOutside } from '../components/NotistackProvider';

/**
 * Global toast bridge to show Notistack notifications from non-component files (like thunks).
 */

export const showErrorToast = (message: string) => {
  const snackbar = getSnackbarOutside();
  if (snackbar) {
    snackbar.enqueueSnackbar(message, { variant: 'error' });
  } else {
    console.error('Snackbar not initialized:', message);
  }
};
